import React from 'react'

const SearchIcon = ({
  className = 'search-icon-svg',
  size = 20,
  title,
  color = 'currentColor',
  ...rest
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 25 24"
    aria-hidden={title ? undefined : 'true'}
    role={title ? 'img' : 'presentation'}
    focusable="false"
    {...rest}>
    {title ? <title>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.729736 9.98777C0.729736 4.47167 5.19572 0 10.7048 0C16.2139 0 20.6798 4.47167 20.6798 9.98777C20.6798 11.7568 20.2197 13.4205 19.4126 14.8629L23.9664 19.4844C24.9891 20.5223 24.9835 22.1921 23.9538 23.2231C22.9052 24.273 21.2001 24.2567 20.1718 23.1869L15.7613 18.5988C14.2782 19.4736 12.5489 19.9755 10.7048 19.9755C5.19572 19.9755 0.729736 15.5039 0.729736 9.98777ZM17.3685 17.42L21.5943 21.8159C21.8563 22.0884 22.2906 22.0926 22.5576 21.8251C22.8199 21.5625 22.8214 21.1372 22.5609 20.8728L18.2606 16.5087C17.9828 16.8311 17.6848 17.1355 17.3685 17.42ZM10.7048 1.97696C6.28617 1.97696 2.70418 5.56352 2.70418 9.98777C2.70418 14.412 6.28617 17.9986 10.7048 17.9986C12.4323 17.9986 14.0292 17.4515 15.3361 16.5208C16.1245 15.9594 16.8071 15.2583 17.3477 14.454C18.205 13.1784 18.7054 11.6431 18.7054 9.98777C18.7054 5.56352 15.1234 1.97696 10.7048 1.97696Z"
      fill={color}
    />
  </svg>
)

export default SearchIcon
